import { createContext, useContext } from 'react';
import useLocalStorage from 'hooks/useLocalStorage';
import { useMenuContext } from './MenuContext';
import { parse } from 'helpers';

const CartContext = createContext(undefined);

const reducer =
  //@ts-ignore
  (state, action) => {
    switch (action.type) {
      case 'remove_product': {
        const { index } = action.payload;
        const newArray = [...state.products];
        newArray.splice(index, 1);
        return {
          ...state,
          products: newArray,
        };
      }
      case 'clean_cart': {
        return {
          ...state,
          products: [],
        };
      }
      case 'change_product_quantity':
        const { index, type } = action.payload;
        const copiedProducts = parse(state.products);
        const productToUpdate = copiedProducts[index];
        copiedProducts[index] = {
          ...productToUpdate,
          count:
            type === 'INCREMENT'
              ? (productToUpdate.count += 1)
              : productToUpdate.count > 1
              ? (productToUpdate.count -= 1)
              : productToUpdate.count,
        };
        return {
          ...state,
          products: copiedProducts,
        };
      case 'add_to_cart':
        return {
          ...state,
          products: [...state.products, action.payload],
        };
      default:
        return state;
    }
  };

interface CartState {
  products: any[];
}
const CartProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { slug } = useMenuContext();
  const [state, setState] = useLocalStorage<CartState>(`cart_${slug}`, {
    products: [],
  });
  //@ts-ignore
  const dispatch = (action: any) => {
    //@ts-ignore
    setState((prev) => {
      const newState = reducer(prev, action);
      return newState;
    });
  };

  return (
    <CartContext.Provider
      //@ts-ignore
      value={{ state, dispatch }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;

export const useCartContext = () => {
  const context = useContext(CartContext);

  if (context === undefined) {
    throw new Error('useCartContext should be used inside a cart provider');
  }
  return context;
};
